export const HomeHeader = () => {
    return (
        <>
            <header
                className="header vh-100 text-center position-relative"
                style={{
                    backgroundImage: "url(../../images/dragoneye2.jpg)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundAttachment: "fixed",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="text-container position-relative d-flex flex-column justify-content-center align-items center h-100">
                    <h5 className="text-primary fs-3fw bold text-uppercase">
                        Home
                    </h5>
                    <h1 className="display-1 fw-bold text-white">
                        Dragonshifty Studios
                    </h1>
                    <p className="roles text-primary text-uppercase fs-4">
                        <span>Programming | </span>
                        <span>music | </span>
                        <span>graphics</span>
                    </p>
                </div>
            </header>
        </>
    );
};
